import type { ReactNode } from 'react'

import { Button } from '@/components/ui/button'

import type { TemplateVariableFormActionsProps } from './template-variable-form.interface'

/**
 * Cancel and Submit button pair for the template variable form.
 * Reusable action bar that can be placed at the bottom of any form.
 */
export const TemplateVariableFormActions: React.FC<TemplateVariableFormActionsProps> = ({
  onCancel,
  isDisabled = false,
  submitLabel = 'Submit',
  cancelLabel = 'Cancel',
}): ReactNode => (
  <div className="template-variable-form-actions flex justify-end gap-2 pt-4">
    <Button
      type="button"
      variant="outline"
      onClick={onCancel}
      disabled={isDisabled}
      className="template-variable-form-cancel"
    >
      {cancelLabel}
    </Button>
    <Button type="submit" disabled={isDisabled} className="template-variable-form-submit">
      {submitLabel}
    </Button>
  </div>
)

TemplateVariableFormActions.displayName = 'TemplateVariableFormActions'
